module.exports = __webpack_public_path__ + "img/7.5ad26ee3.png";